/* eslint-disable */
import React, { useEffect, useRef, useState } from 'react';
import { RideButton } from '@rimac-seguros/ride-system-components';

import { Input, Select } from '../../../../components/atoms';
import {
  getDepartaments,
  getProvinces,
  getDistricts,
  registerLead,
  createQuote,
  addThirdInQuote,
  getSession,
  registerDps,
  calculateDiscount,
  selectPlan,
  abortRequest,
} from '../../../../services/clientServices';
import { useAppContext } from '../../../../AppProvider';
import { getErrorPage } from '../../../../utils/helpers';
import {
  requestDps,
  requestQuoteData,
  requestSession,
  requestThird,
  requestCalculatePlan,
  requestSelectPlan,
} from '../../../../services/requests';
import RegisterAuditory from '../../../../auditory/component/RegisterAuditory';
import { AUDITORY_MODEL } from '../../../../models/step-address';
import { useHistory } from '../../../../hooks/useHistory';
// import { getTagVirtual } from '../../../../utils/analytics';

const StepAddress = () => {
  const [departamentsList, setDeparatamentsList] = useState('');
  const [departmentSelected, setDepartmentSelected] = useState('');
  const [provincesList, setProvincesList] = useState('');
  const [provinceSelected, setProvinceSelected] = useState('');
  const [districtsList, setDistrictsList] = useState('');
  const [districtSelected, setDistrictSelected] = useState('');
  const [address, setAddress] = useState('');
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(true);
  const [loadingDepartment, setLoadingDepartment] = useState(false);
  const [loadingProvince, setLoadingProvince] = useState(false);
  const [loadingDistrict, setLoadingDistrict] = useState(false);
  const {
    state: {
      leadData,
      planSelected,
      departmentLoaded,
      deparment
    },
    state,
    dispatch,
  } = useAppContext();
  const { navigate } = useHistory();

  const constructDepartaments = (abortController) => {

    const sendSignal = (signal) => {
      abortController.current.signal = signal;
    };

    const renderDepartaments = (departament) => departament.map((element) => (
      <option
        key={element.descripcionDepartamento}
        value={element.ideDepartamento}
        id={element.codigoExternoDepartamento}
      >
        {element.descripcionDepartamento}
      </option>
    ));

    setLoadingDepartment(true);
    if (departmentLoaded) {
      const departamentList = renderDepartaments(deparment);
      setDeparatamentsList(departamentList);
      setLoadingDepartment(false);
      return;
    }
    getDepartaments({ idePais: '80' }, sendSignal)
      .then((departaments) => {
        setLoadingDepartment(false);
        const filterDepartments = departaments.filter((e) => e.descripcionDepartamento !== 'NO DETERMINADO');
        const departamentList = renderDepartaments(filterDepartments);
        dispatch({ type: 'SET_DEPARTMENT', payload: filterDepartments });
        setDeparatamentsList(departamentList);
      })
      .catch((error) => {
        navigate && navigate(getErrorPage(error, 'BUSCAR_DEPARTAMENTOS'))
      });
  };

  const constructProvinces = (value) => {
    setLoadingProvince(true);
    getProvinces({ ideDepartamento: value }, (signal) => {
      provinceController.current.signal = signal;
    })
      .then((provinces) => {
        setLoadingProvince(false);
        const filterProvinces = provinces.filter((e) => e.descripcionProvincia !== 'NO DETERMINADO');
        const provinceList = filterProvinces.map((element) => (
          <option
            key={element.descripcionProvincia}
            value={element.ideProvincia}
            id={element.codigoExternoProvincia}
          >
            {element.descripcionProvincia}
          </option>
        ));
        setProvincesList(provinceList);
      })
      .catch((error) => navigate(getErrorPage(error, 'BUSCAR_PROVINCIAS')));
  };

  const constructDistricts = (value) => {
    setLoadingDistrict(true);
    getDistricts({ ideProvincia: value }, (signal) => {
      districtController.current.signal = signal;
    })
      .then((districts) => {
        setLoadingDistrict(false);
        const filterDistricts = districts.filter((e) => e.descripcionDistrito !== 'NO DETERMINADO');
        const districtList = filterDistricts.map((element) => (
          <option
            key={element.descripcionDistrito}
            value={element.ideDistrito}
            id={element.codigoExternoDistrito}
          >
            {element.descripcionDistrito}
          </option>
        ));
        setDistrictsList(districtList);
      })
      .catch((error) => navigate(getErrorPage(error, 'BUSCAR_DISTRITOS')));
  };

  const valueData = () => {
    setDisabled(!(departmentSelected !== '' && districtSelected !== '' && provinceSelected !== '' && address !== ''));
  };

  const abortController = useRef({ signal: null, abort: abortRequest });
  const provinceController = useRef({ signal: null, abort: abortRequest });
  const districtController = useRef({ signal: null, abort: abortRequest });
  const discountController = useRef({ signal: null, abort: abortRequest });
  const createQuoteController = useRef({ signal: null, abort: abortRequest });
  const selectPlanController = useRef({ signal: null, abort: abortRequest });
  const addThirdInQuoteController = useRef({ signal: null, abort: abortRequest });
  const registerDpsController = useRef({ signal: null, abort: abortRequest });
  const checkoutSessionController = useRef({ signal: null, abort: abortRequest });

  useEffect(() => {
    constructDepartaments(abortController);
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 2);

    return () => {
      abortController.current?.abort(abortController.current?.signal);
      provinceController.current?.abort(provinceController.current?.signal);
      districtController.current?.abort(districtController.current?.signal);
      discountController.current?.abort(discountController.current?.signal);
      createQuoteController.current?.abort(createQuoteController.current?.signal);
      selectPlanController.current?.abort(selectPlanController.current?.signal);
      addThirdInQuoteController.current?.abort(addThirdInQuoteController.current?.signal);
      registerDpsController.current?.abort(registerDpsController.current?.signal);
      checkoutSessionController.current?.abort(checkoutSessionController.current?.signal);
    };
  }, []);

  useEffect(() => {
    valueData();
  }, [departmentSelected, districtSelected, provinceSelected, address]);

  function handleNextStep() {
    setLoading(true);
    const requestLead = leadData;
    requestLead.finalizado = 5;
    registerLead(requestLead)
      .then(() => {
        dispatch({ type: 'ADD_LEAD_DATA', payload: requestLead });
      })
      .catch((error) => navigate(getErrorPage(error, 'AGREGAR_LEADS')));
    const descDept = departamentsList.filter(
      (e) => e.props.value === parseInt(departmentSelected, 10),
    );
    const descProv = provincesList.filter(
      (e) => e.props.value === parseInt(provinceSelected, 10),
    );
    const descDist = districtsList.filter(
      (e) => e.props.value === parseInt(districtSelected, 10),
    );

    const request = {
      province: { id: descProv[0].props.id, desc: descProv[0].props.children },
      district: { id: descDist[0].props.id, desc: descDist[0].props.children },
      departament: { id: descDept[0].props.id, desc: descDept[0].props.children },
      address,
      idPais: '428',
    };
    dispatch({
      type: 'SAVE_ADDRESS',
      payload: request,
    });
    state.address = request;
    createQuote(requestQuoteData({...state}, 'lastStep'), (signal) => {
      createQuoteController.current.signal = signal;
    })
      .then((payload) => {
        const reqPlanSelected = {
          idQuote: payload.ideCotizacion,
          planFlexSelected: planSelected,
        };
        selectPlan(requestSelectPlan(reqPlanSelected), (signal) => {
          selectPlanController.current.signal = signal;
        }).then(() => {
          addThirdInQuote(requestThird({...state}, 'lastStep'), (signal) => {
            addThirdInQuoteController.current.signal = signal
          })
            .then(() => {              
              calculateDiscount(requestCalculatePlan(payload.ideCotizacion, false), (signal) => {
                discountController.current.signal = signal;
              })
                .then((data) => {
                  const plan = data[0]?.rptaCalculoPrima[0];
                  planSelected.priceDiscount = plan.mtoCuota;
                  dispatch({ type: 'SAVE_PLAN_SELECTED', payload: planSelected });
                  dispatch({ type: 'SAVE_DISCOUNT', payload: plan });
                  registerDps(requestDps({...state}), (signal) => {
                    registerDpsController.current.signal = signal;
                  })
                    .then(() => {
                      getSession(requestSession(payload.ideCotizacion), (signal) => {
                        checkoutSessionController.current.signal = signal;
                      })
                        .then((res) => {
                          dispatch({ type: 'SAVE_SESSION', payload: res.sesion.token });
                          navigate('/comprar/seguro-salud-flexible/pago');
                        })
                        .catch((error) => {
                          navigate(getErrorPage(error, 'GUARDAR_SESSION_PAGO'));
                        });
                    })
                    .catch((error) => {
                      navigate(getErrorPage(error, 'REGISTRAR_DPS'));
                    });
                })
                .catch((error) => navigate(getErrorPage(error, 'CALCULAR_DESCUENTO')));
            })
            .catch((error) => navigate(getErrorPage(error, 'AGREGAR_TERCERO')));
        })
        .catch((error) => navigate(getErrorPage(error, 'SELECCIONAR_PLAN')))
      })
      .catch((error) => navigate(getErrorPage(error, 'ACTUAlIZAR_COTIZACION')));
  }

  return (
    <div className="step-container address">
      <RegisterAuditory authoring={AUDITORY_MODEL} />
      <div className="container-top">
        <div className="container">
          <div className="step-container-container address">
            <div className="address-content">
              <div className="address-content__title">
                ¡Ya solo falta un paso!
              </div>
              <h4 className="address-content__subtitle">
                Por favor, ingresa tu dirección exacta.
              </h4>
            </div>
          </div>
        </div>
      </div>
      <div className="container-bottom">
        <div className="container">
          <div className="step-container-container address">
            <div className="address-content">
              <div className="address-content__selects">
                <h4 className="address-content__selects-desc">
                  Mi dirección
                </h4>
                <div className="address-content__selects-list">
                  <Select
                    label="Departamento"
                    type="text"
                    value={departmentSelected}
                    onChange={(value) => {
                      setDepartmentSelected(value);
                      constructProvinces(value);
                      setProvinceSelected('');
                      setDistrictSelected('');
                    }}
                    options={departamentsList}
                    specialClass={departmentSelected ? 'active' : ''}
                    loading={loadingDepartment}
                  />
                  <Select
                    label="Provincia"
                    type="text"
                    value={provinceSelected}
                    onChange={(value) => {
                      setProvinceSelected(value);
                      constructDistricts(value);
                      setDistrictSelected('');
                    }}
                    options={provincesList}
                    specialClass={provinceSelected ? 'active' : ''}
                    loading={loadingProvince}
                  />
                  <Select
                    label="Distrito"
                    type="text"
                    value={districtSelected}
                    onChange={(value) => {
                      setDistrictSelected(value);
                    }}
                    options={districtsList}
                    specialClass={districtSelected ? 'active' : ''}
                    loading={loadingDistrict}
                  />
                  <Input
                    label="Dirección completa"
                    type="text"
                    value={address}
                    onChange={(value) => {
                      setAddress(value);
                    }}
                  />
                  <div className="button-wrpr">
                    <RideButton
                      loading={loading}
                      type="primary"
                      text="Continuar"
                      size="x-large"
                      disabled={disabled}
                      onClick={() => handleNextStep()}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StepAddress;
